import { GButton, IGButtonInject } from '@monorepo/base/src/components/buttons/group/button/g-button';
import { Icon, IconFonts } from '@monorepo/base/src/components/icon/icon';
import { Radio } from '@monorepo/base/src/components/form/radio/radio';
import { getTheme } from '@monorepo/tools/src/lib/get-config';
import styles from './gbutton-box-with-icon.module.scss';
import { IDebugProps } from '@monorepo/tools/src/lib/interfaces/debug';
import { suffixToDataAttr } from '@monorepo/tools/src/lib/models/data-attr.model';

export interface IGButtonBoxWithIcon {
	value: string;
	icon?: string | JSX.Element;
	title?: string;
	description?: string;
	mini?: boolean;
	multi?: boolean;
	badge?: string | JSX.Element;
	disabledGroup?: boolean;
	disabled?: boolean;
	debugProps?: IDebugProps;
	classNames?: string;
}
export const GButtonBoxWithIcon = (props: IGButtonBoxWithIcon) => {
	// The rest is all props that come from ButtonGroup clone element
	const { value, title, description, icon, mini, multi, badge, disabled, disabledGroup, debugProps, classNames, ...rest } = props;
	const { dataAttrs } = debugProps || {};
	const ButtonContent = (gButtonProps: IGButtonInject) => {
		const { isActive } = gButtonProps;
		return (
			<div className={styles.wrapper}>
				<div className={styles.radio}>
					<Radio
						classNames={styles.onHover}
						disabled={disabled || disabledGroup}
						iconColor={getTheme().primary700}
						multi={multi}
						isActive={isActive}
					/>
				</div>
				{badge ? <div className={styles.badge}>{badge}</div> : null}
				{icon ? (
					<Icon
						isMFP={true}
						font={IconFonts.Outlined}
						className={`${styles.icon} ${disabled || disabledGroup ? styles.disabled : ''}`}>
						{icon}
					</Icon>
				) : null}
				<div className={styles.info}>
					<div className={`${styles.title} ${disabled || disabledGroup ? styles.disabled : ''}`}>{title}</div>
					<div className={`${styles.description} ${disabled || disabledGroup ? styles.disabled : ''}`}>{description}</div>
				</div>
			</div>
		);
	};

	return (
		<GButton
			disabled={disabled || disabledGroup}
			className={`${styles.gbutton} ${mini ? styles.mini : ''} ${classNames}`}
			value={value}
			multi={multi}
			{...rest}
			debugProps={{ dataAttrs: suffixToDataAttr(`_${value?.toLowerCase()}`, dataAttrs) }}>
			{gbuttonProps => <ButtonContent {...gbuttonProps} />}
		</GButton>
	);
};
GButtonBoxWithIcon.displayName = 'GButton'; // for use in children.map loop
